import { defineMessages } from 'react-intl';

export default defineMessages({
    autoShopsDirections: {
        id: 'wmic.capabilities.autoshops.models.directions',
        defaultMessage: 'Directions'
    },
});
